<template>
    <div id="wizard-gdpr">
        <div class="container-fluid">
            <div class="form-container row">

                <!--STEP 1-->
                <transition name="slide">
                    <div
                        id="step-1"
                        class="step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                        v-if="isStep1"
                    >
                        <p v-html="$t('label_titolare_trattamento_dati')"></p>
                        <validation-observer
                            v-slot="{ handleSubmit }"
                            tag="form"
                            ref="wizard-gdpr-form-1"
                            id="wizardGdprFormStep1"
                        >
                            <fieldset class="mt-3">
                                <div class="form-row">
                                    <div class="mb-3 col-sm-12">
                                        <label for="ragione-sociale">{{ $t("Ragione sociale") }}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                type="text"
                                                name="ragione-sociale"
                                                id="ragione-sociale"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.ragioneSociale"
                                            >
                                            </b-form-input>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="nazione">{{ $t("Nazione") }}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="nazione"
                                                id="nazione"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.nazione"
                                            >
                                                <option
                                                    v-for="country in countryList"
                                                    :key="country.id"
                                                    :value="country.id"
                                                >{{country.name}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="province">{{$t('Provincia')}}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="province"
                                                id="province"
                                                ref="provincia"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.provincia"
                                                @change="onChangeProvince"
                                            >
                                                <option value="">{{$t('Seleziona provincia')}}</option>
                                                <option
                                                    v-for="province in provincesList"
                                                    v-bind:key="province.Sigla"
                                                    v-bind:value="province.Sigla"
                                                >
                                                    {{province.Provincia}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <label for="city">{{ $t("Città") }} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="city"
                                                id="city"
                                                ref="citta"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.citta"
                                                @change="onChangeCity"
                                            >
                                                <option
                                                    value=""
                                                    :selected="'sel'"
                                                >{{$t('Seleziona città')}}
                                                </option>
                                                <option
                                                    v-for="(key, value) in cities"
                                                    v-bind:key="value"
                                                    v-bind:value="value"
                                                >
                                                    {{value}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <label for="zip">{{ $t("CAP") }} <span class="text-danger">*</span></label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <select
                                                name="zip"
                                                id="zip"
                                                ref="cap"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.cap"
                                            >
                                                <option value="">{{$t('Seleziona cap')}}</option>
                                                <option
                                                    v-for="zip in zip"
                                                    v-bind:key="zip.cap"
                                                    v-bind:value="zip.cap"
                                                >
                                                    {{zip.cap}}
                                                </option>
                                            </select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <label for="indirizzo">{{ $t("Indirizzo") }}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                type="text"
                                                name="indirizzo"
                                                id="indirizzo"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.indirizzo"
                                            >
                                            </b-form-input>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3 form-group">
                                        <label for="email">{{ $t("Email") }}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{errors}"
                                        >
                                            <b-form-input
                                                type="email"
                                                name="email"
                                                id="email"
                                                ref="email"
                                                class="rounded-pill rilievo-ombra-interna"
                                                v-model="shop.email"
                                            >
                                            </b-form-input>
                                            <span class="text-danger">{{ $t(errors[0]) }}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3 form-group">
                                        <label for="telefono">{{ $t("Telefono") }}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                type="tel"
                                                name="telefono"
                                                id="telefono"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.telefono"
                                            >
                                            </b-form-input>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3 form-group">
                                        <label for="piva">{{ $t("Partita IVA") }}
                                            <span class="text-danger">*</span>
                                        </label>
                                        <validation-provider
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <b-form-input
                                                type="text"
                                                name="piva"
                                                id="piva"
                                                class="form-control rounded-pill rilievo-ombra-interna"
                                                v-model="shop.piva"
                                            >
                                            </b-form-input>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <div class="col-sm-6 mb-3 form-group">
                                        <label for="fax">{{ $t("Fax") }}
                                        </label>
                                        <b-form-input
                                            type="text"
                                            name="fax"
                                            id="fax"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            v-model="shop.fax"
                                        >
                                        </b-form-input>
                                    </div>
                                </div>
                            </fieldset>
                            <div class="text-md-right">
                                <a
                                    role="button"
                                    class="pulsante-step-next btn btn-primary btn-rikorda1 mt-3 mb-0 d-block d-md-inline-block mx-auto mx-md-0"
                                    @click.prevent="handleSubmit(goToStep2)"
                                >{{ $t('Continua') }}</a>
                            </div>
                        </validation-observer>
                    </div>
                </transition>
                <!--/STEP 1-->

                <!--STEP 2-->
                <transition name="slide">
                    <div
                        id="step-2"
                        class="step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                        v-if="isStep2"
                    >
                        <p v-html="$t('label_titolare_trattamento_dati')"></p>
                        <validation-observer
                            v-slot="{ handleSubmit }"
                            tag="form"
                            ref="wizard-gdpr-form-2"
                            id="wizardGdprFormStep2"
                        >
                            <fieldset class="mt-3">
                                <div class="form-row">
                                    <div class="mb-3 col-sm-12">
                                        <div class="mb-3">
                                            <p class="mb-3">Per informare gli utenti della PhotoGallery sul trattamento dei loro dati puoi utilizzare
                                                un template (<a
                                                    href="#"
                                                    @click.prevent="onReadFullPage('INFORMATIVA')"
                                                >
                                                    {{$t('visualizza il template')}}
                                                </a>) che abbiamo predisposto noi e che devi verificare e validare,
                                                oppure puoi caricare una tua informativa adeguata allo strumento; in ogni caso,
                                                Rikorda non si assume nessuna responsabilità sul contenuto in quanto le informazioni da
                                                fornire agli interessati sono in capo al Titolare del trattamento. Cosa scegli?</p>
                                            <b-form-radio-group
                                                id="btn-radios-2"
                                                v-model="docTypeSelected"
                                                :options="docTypeOptions"
                                                buttons
                                                button-variant="outline-primary w-50 btn-rikorda-doctype"
                                                name="radio-btn-outline"
                                                @change="handleDocTypeChange"
                                            ></b-form-radio-group>
                                        </div>
                                        <div>
                                            <span>{{$t('Hai un DPO (in genere per i negozi non è obbligatorio)?')}}
                                                <font-awesome-icon
                                                    id="dpoHelpIcon"
                                                    :icon="['fas', 'question-circle']"
                                                    :title="$t('Chi è Data Protection Officier (DPO)?')"
                                                    v-b-modal.dpohelp-modal
                                                />
                                            </span>
                                            <b-form-radio-group
                                                id="radio-group-2"
                                                v-model="hasDPO"
                                                name="radio-sub-component"
                                            >
                                                <b-form-radio
                                                    v-model="hasDPO"
                                                    name="has-dpo-radio"
                                                    value="SI"
                                                >{{ $t('Sì') }}</b-form-radio>
                                                <b-form-radio
                                                    v-model="hasDPO"
                                                    name="has-dpo-radio"
                                                    value="NO"
                                                >{{ $t('No') }}</b-form-radio>
                                            </b-form-radio-group>
                                            <div v-if="hasDPO == 'SI'">
                                                <validation-provider
                                                    rules="required"
                                                    v-slot="{ validate, errors }"
                                                >
                                                    <b-form-input
                                                        type="text"
                                                        name="dpoValue"
                                                        id="dpo"
                                                        class="form-control rounded-pill rilievo-ombra-interna"
                                                        v-model="shop.dpo"
                                                        placeholder="Inserisci nominativo del DPO"
                                                    >
                                                    </b-form-input>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </validation-provider>
                                                <span class="float-right">{{ $t('Qui le') }} <a
                                                        href="https://www.gpdp.it/web/guest/home/docweb/-/docweb-display/docweb/8036793"
                                                        target="_blank"
                                                    >{{ $t('FAQ del Garante') }}</a></span>
                                            </div>
                                            <validation-provider
                                                v-if="docTypeSelected == 'default'"
                                                :rules="{required: {allowFalse: false}}"
                                                v-slot="{errors}"
                                            >
                                                <b-form-checkbox
                                                    v-model="checkbox.informativa"
                                                    name="checkbox-informativa"
                                                    class="mt-3"
                                                >
                                                    {{$t("Ho letto l'informativa del fotografo agli utenti sul trattamento dei dati ed accetto sotto la mia responsabilità tale informativa riservandomi la possibilità di sostituirla anche successivamente nella sezione privacy e condizioni")}}
                                                </b-form-checkbox>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </div>
                                        <div
                                            v-if="docTypeSelected == 'custom'"
                                            class="mt-3"
                                        >
                                            <h6>{{$t('Carica la tua informativa personalizzata (in formato PDF)')}}</h6>
                                            <p class="font-weight-bold">Attenzione: il file è soggetto ad approvazione. Potrebbero essere necessari 15 giorni di tempo.</p>
                                            <div class="mt-3 mb-3">
                                                {{$t('Voglio essere messo in contatto con il vostro ufficio legale')}}
                                                <b-card>
                                                    <fieldset>
                                                        <div class="form-row">
                                                            <h6>{{$t('Mittente')}}</h6>
                                                            <div class="mb-3 col-sm-12">
                                                                {{ shop.ragioneSociale }}<br />
                                                                {{ shop.indirizzo }} {{ shop.cap }} - {{ shop.citta }} ({{ shop.provincia }})<br />
                                                                Informazioni di contatto:<br />
                                                                <font-awesome-icon
                                                                    class="ml-1 mr-1"
                                                                    :icon="['fas', 'phone']"
                                                                /> {{ shop.telefono }}<br />
                                                                <font-awesome-icon
                                                                    class="ml-1 mr-1"
                                                                    :icon="['fas', 'envelope']"
                                                                /> {{ shop.email }}
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <validation-provider
                                                                rules="required"
                                                                v-slot="{errors}"
                                                                class="mb-3 w-100"
                                                            >
                                                                <h6>{{$t('Messaggio')}}</h6>
                                                                <textarea
                                                                    class="w-100"
                                                                    rows=4
                                                                    placeholder="Inserisci il tuo messaggio"
                                                                    v-model="message"
                                                                ></textarea>
                                                                <span class="text-danger">{{errors[0]}}</span>
                                                            </validation-provider>
                                                        </div>
                                                        <div class="form-row">
                                                            <validation-provider
                                                                rules="required|ext:pdf"
                                                                ref="provider"
                                                                class="w-100"
                                                                v-slot="{ validate, errors }"
                                                            >
                                                                <h6>{{$t('Informativa personalizzzata')}}</h6>
                                                                <div class="mt-3">
                                                                    <input
                                                                        type="file"
                                                                        accept="application/pdf"
                                                                        name="custom-gdpr"
                                                                        ref="customGdpr"
                                                                        id="custom-gdpr"
                                                                        class="col order-3 order-md-2 mt-2 mt-md-0"
                                                                        @change="handleFileChange"
                                                                    />
                                                                    <span class="text-danger">{{errors[0]}}</span>
                                                                </div>
                                                            </validation-provider>
                                                        </div>
                                                    </fieldset>
                                                </b-card>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <div class="text-md-right">
                                <a
                                    role="button"
                                    class="btn btn-light btn-rikorda2 border my-1 float-left"
                                    @click.prevent="goToStep1()"
                                >{{ $t('Indietro') }}</a>
                                <a
                                    role="button"
                                    class="btn btn-primary btn-rikorda1 my-1"
                                    @click.prevent="docTypeSelected == 'custom' ? handleSubmit(goToStepCustom) : handleSubmit(goToStep3)"
                                >{{ $t('Continua') }}</a>
                            </div>
                        </validation-observer>
                    </div>
                </transition>
                <!--/STEP 2-->

                <!--STEP 3-->
                <transition name="slide">
                    <div
                        id="step-3"
                        class="step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                        v-if="isStep3"
                    >
                        <p v-html="$t('label_titolare_trattamento_dati')"></p>
                        <p>{{ $t('Devi approvare questi documenti:') }}</p>
                        <validation-observer
                            v-slot="{ handleSubmit }"
                            tag="form"
                            ref="wizard-gdpr-form-3"
                            id="wizardGdprForm3"
                        >
                            <fieldset>

                                <h5>{{ $t('Contratto di nomina del responsabile del trattamento (DPA)') }}</h5>
                                <div class="mb-5">
                                    <div
                                        class="textarea"
                                        v-html="getFilledDocument('DPA')"
                                    ></div>
                                    <a
                                        style="float: right"
                                        href="#"
                                        @click.prevent="onReadFullPage('DPA')"
                                    >
                                        {{$t('Leggi a piena pagina')}}
                                    </a>
                                </div>

                                <h5>{{ $t("Informativa Photogallery del fotografo agli utenti finali sul trattametno dei dati") }}</h5>
                                <div class="mb-5">
                                    <div
                                        v-if="!hasConfirmedDoc"
                                        class="textarea"
                                        v-html="getFilledDocument('INFORMATIVA')"
                                    ></div>
                                    <div
                                        v-else
                                        id="iframe-informativa"
                                        style="width:100%;height:300px;overflow:auto;-webkit-overflow-scrolling: touch;"
                                    >
                                        <embed
                                            :src="getDocumentUrlEndpoint()"
                                            type="application/pdf"
                                            width="100%"
                                            height="100%"
                                        >
                                    </div>
                                    <a
                                        style="float: right"
                                        href="#"
                                        @click.prevent="onReadFullPage('INFORMATIVA')"
                                    >
                                        {{$t('Leggi a piena pagina')}}
                                    </a>
                                </div>
                                <div class="mb-5">
                                    <validation-provider
                                        :rules="{required: {allowFalse: false}}"
                                        v-slot="{errors}"
                                    >
                                        <b-form-checkbox
                                            id="checkbox-dpa"
                                            v-model="checkbox.dpa"
                                            name="checkbox-dpa"
                                        >
                                            {{$t('label_accettazione_dpa')}}
                                        </b-form-checkbox>
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                    <validation-provider
                                        v-if="!hasConfirmedDoc"
                                        :rules="{required: {allowFalse: false}}"
                                        v-slot="{errors}"
                                    >
                                        <b-form-checkbox
                                            id="checkbox-termini-condizioni-rikorda"
                                            v-model="checkbox.terminiRikorda"
                                            name="checkbox-termini-condizioni-rikorda"
                                        >
                                            {{ $t('Accetto i termini e condizioni di Rikorda anche per il servizio RikordaEventi') }}
                                        </b-form-checkbox>
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </fieldset>
                            <div class="text-md-right">
                                <a
                                    v-if="!hasConfirmedDoc"
                                    role="button"
                                    class="btn btn-light btn-rikorda2 border my-1 float-left"
                                    @click.prevent="goToStep2()"
                                >{{ $t('Indietro') }}</a>
                                <a
                                    role="button"
                                    class="btn btn-primary btn-rikorda1 my-1"
                                    @click.prevent="handleSubmit(goToStep4)"
                                >{{ $t('Continua') }}</a>
                            </div>
                        </validation-observer>
                    </div>
                </transition>
                <!--/STEP 3-->

                <!--STEP 4-->
                <transition name="slide">
                    <div
                        id="step-4"
                        class="step col-lg-8 offset-lg-2 col-md-10 offset-md-1"
                        v-if="isStep4"
                    >
                        <p v-html="$t('label_titolare_trattamento_dati')"></p>
                        <p>{{ $t('Devi approvare questi documenti:') }}</p>

                        <validation-observer
                            v-slot="{ handleSubmit }"
                            tag="form"
                            ref="wizard-gdpr-form-4"
                            id="wizardGdprFormStep4"
                        >
                            <h5>{{ $t('Termini e condizioni del servizio Rikorda Eventi - Fotografo') }}</h5>
                            <fieldset>
                                <div class="mb-5">
                                    <div
                                        class="textarea"
                                        v-html="getFilledDocument('TERMINICONDIZIONIRIKORDAEVENTIFOTOGRAFO')"
                                    ></div>
                                    <a
                                        style="float: right"
                                        href="#"
                                        @click.prevent="onReadFullPage('TERMINICONDIZIONIRIKORDAEVENTIFOTOGRAFO')"
                                    >
                                        {{$t('Leggi a piena pagina')}}
                                    </a>
                                </div>
                            </fieldset>
                            <h5>{{ $t('Termini e condizioni del servizio (Fotografo - Utenti finali)') }}</h5>
                            <fieldset>
                                <div class="mb-5">
                                    <div
                                        class="textarea"
                                        v-html="getFilledDocument('TERMINICONDIZIONIFOTOGRAFOUTENTI')"
                                    ></div>
                                    <a
                                        style="float: right"
                                        href="#"
                                        @click.prevent="onReadFullPage('TERMINICONDIZIONIFOTOGRAFOUTENTI')"
                                    >
                                        {{$t('Leggi a piena pagina')}}
                                    </a>
                                </div>
                                <div class="mb-3">
                                    <validation-provider
                                        :rules="{required: {allowFalse: false}}"
                                        v-slot="{errors}"
                                    >
                                        <b-form-checkbox
                                            id="checkbox-termini-condizioni-rikordaeventi-fotografo"
                                            v-model="checkbox.terminiEventiFotografo"
                                            name="checkbox-termini-condizioni-rikordaeventi-fotografo"
                                        >
                                            {{$t("Ho letto ed accetto i Termini e condizioni del servizio Rikorda Eventi - Fotografo")}}
                                        </b-form-checkbox>
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="mb-3">
                                    <validation-provider
                                        :rules="{required: {allowFalse: false}}"
                                        v-slot="{errors}"
                                    >
                                        <b-form-checkbox
                                            id="checkbox-termini-condizioni-fotografo-utenti"
                                            v-model="checkbox.terminiFotografoUtenti"
                                            name="checkbox-termini-condizioni-fotografo-utenti"
                                        >
                                            {{$t("Ho letto ed accetto i termini e condizioni del servizio Fotografo - Utenti finali e l'accetto sotto la mia responsabilità (tale documento sarà visualizzato e fatto accettare agli utenti quando accedono alle mie gallery).")}}
                                        </b-form-checkbox>
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </fieldset>
                            <div class="text-md-right">
                                <a
                                    role="button"
                                    class="btn btn-light btn-rikorda2 border my-1 float-left"
                                    @click.prevent="goToStep3()"
                                >{{ $t('Indietro') }}</a>
                                <a
                                    role="button"
                                    class="btn btn-primary btn-rikorda1 my-1"
                                    @click.prevent="handleSubmit(acceptGdpr)"
                                >{{ $t('Continua') }}</a>
                            </div>
                        </validation-observer>
                    </div>
                </transition>
                <!--STEP 4-->
            </div>
        </div>

        <b-modal
            id="dpohelp-modal"
            title="Chi è Data Protection Officier (DPO)?"
            size="xl"
            ok-only
        >
            <p class="my-4 text-justify">
                Il responsabile della protezione dei dati personali (anche conosciuto con la dizione in lingua inglese data protection officer – DPO) è una figura prevista dal Regolamento (UE) 2016/679 -GDPR. Si tratta di un soggetto designato per assolvere a funzioni di supporto e controllo, consultive, formative e informative relativamente all'applicazione del Regolamento medesimo. Sono tenuti alla designazione del DPO quei soggetti le cui principali attività ("core business") consistono in trattamenti che richiedono il monitoraggio regolare e sistematico degli interessati su larga scala o in trattamenti su larga scala di categorie particolari di dati personali o di dati relative a condanne penali e a reati. Sono tenuti alla nomina, a titolo esemplificativo e non esaustivo: istituti di credito; imprese assicurative; sistemi di informazione creditizia; società finanziarie; società di informazioni commerciali; società di revisione contabile; società di recupero crediti; istituti di vigilanza; partiti e movimenti politici; sindacati; caf e patronati; società operanti nel settore delle "utilities" (telecomunicazioni, distribuzione di energia elettrica o gas); imprese di somministrazione di lavoro e ricerca del personale; società operanti nel settore della cura della salute, della prevenzione/diagnostica sanitaria quali ospedali privati, terme, laboratori di analisi mediche e centri di riabilitazione; società di call center; società che forniscono servizi informatici; società che erogano servizi televisivi a pagamento.
                Difficilmente un negozio o studio fotografico ha obbligo di designare un DPO.
                Per approfondimenti, consulta le <a
                    href="https://www.garanteprivacy.it/home/docweb/-/docweb-display/docweb/8036793"
                    target="_blank"
                >FAQ del Garante</a>
            </p>
        </b-modal>

        <b-modal
            id="customgdpr-modal"
            title="Invio informativa personalizzata effettuato"
            ok-title="Chiudi"
            ok-only
            @ok="onCustomGdprModalOk"
            @close="onCustomGdprModalOk"
        >
            <p
                class="my-4 text-justify"
                :class="{'text-danger': !customGdprResult}"
            >
                {{ customGdprMessage }}
            </p>
        </b-modal>

        <GDPRViewer
            ref="gdprViewer"
            :gdpr="gdprToView"
            :title="gdprTitleToView"
            :shop="shop"
            :hasCustomGdpr="hasCustomGDPR"
        >
            <slot></slot>
        </GDPRViewer>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { BFormInput, BFormCheckbox } from "bootstrap-vue";
import GDPRViewer from "../GDPRViewer";
import { required, email, ext } from "vee-validate/dist/rules";

export default {
    name: "BackendWizardGDPR",
    components: {
        GDPRViewer,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormCheckbox
    },
    props: [
        "hasConfirmedDoc",
        "gdpr",
        "shop",
        "countryList",
        "provincesList",
        "citiesList",
        "zipList"
    ],
    data() {
        return {
            titles: {
                1: "Controlla e completa i tuoi dati personali",
                2: "Accettazione informativa agli utenti",
                3: "Accettazione e trattamento delle condizioni",
                4: "Termini e condizioni"
            },
            wizardStep: this.hasAcceptedGDPR ? 3 : 1,
            checkbox: {
                dpa: false,
                informativa: false,
                terminiRikorda: false,
                terminiEventi: false
            },
            gdprToView: null,
            gdprTitleToView: null,
            cities: this.citiesList,
            zip: this.zipList,
            docTypeSelected: "default",
            docTypeOptions: [
                {
                    text:
                        "Voglio usare il vs. template che confermo essere adeguato",
                    value: "default"
                },
                {
                    text: "Voglio caricare una mia informativa",
                    value: "custom"
                }
            ],
            hasDPO: "NO",
            hasCustomGDPR: false,
            message: "",
            customGdprResult: false,
            customGdprMessage: ""
        };
    },
    mounted() {
        this.wizardStep = this.hasConfirmedDoc ? 3 : 1;
        this.hasCustomGDPR = this.hasConfirmedDoc;
        this.updateTitle();
    },
    methods: {
        updateTitle() {
            var title = this.titles[this.wizardStep]
                ? this.titles[this.wizardStep]
                : this.titles[1];
            this.$emit("updateTitle", title);
        },
        goToStep1() {
            this.wizardStep = 1;
            this.updateTitle();
        },
        goToStep2() {
            this.wizardStep = 2;
            this.updateTitle();
        },
        goToStep3() {
            this.wizardStep = 3;
            this.updateTitle();
        },
        goToStep4() {
            this.wizardStep = 4;
            this.updateTitle();
        },
        goToStepCustom() {
            this.$api
                .backendCustomGdprRequest(this.message)
                .then((response) => {
                    console.debug("BACKEND_CUSTOM_GDPR_REQUEST", response);
                    this.customGdprResult = true;
                    this.customGdprMessage = this.$t(
                        "L'informativa è stata inviata e sarà sottoposta ad approvazione da parte dell'ufficio legale."
                    );
                })
                .catch((error) => {
                    console.error("BACKEND_CUSTOM_GDPR_REQUEST", error);
                    this.customGdprResult = false;
                    this.customGdprMessage = this.$t(
                        "C'è stato un errore nell'invio dell'informativa."
                    );
                })
                .finally(() => {
                    this.$bvModal.show("customgdpr-modal");
                });
        },
        onCustomGdprModalOk() {
            this.$emit("close");
        },
        onChangeProvince() {
            this.$refs.provincia.disabled = true;
            this.$refs.citta.disabled = true;
            this.$refs.cap.disabled = true;
            this.$api
                .getItalyCities(this.shop.provincia)
                .then((result) => {
                    console.debug("GET_ITALY_CITIES", result);
                    this.cities = result.cities;
                    if (!this.cities || !this.cities[this.shop.citta]) {
                        this.shop.citta = "";
                    }
                    this.onChangeCity();
                    this.$refs.provincia.disabled = false;
                    this.$refs.citta.disabled = false;
                    this.$refs.cap.disabled = false;
                })
                .catch((error) => {
                    console.error("GET_ITALY_CITIES", error);
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        },
        onChangeCity() {
            if (this.cities[this.shop.citta]) {
                this.zip = this.cities[this.shop.citta];
                if (
                    this.zip.filter((zip) => {
                        return zip.cap === this.shop.cap;
                    }).length === 0
                ) {
                    this.shop.cap = "";
                }
            } else {
                this.zip = [];
                this.shop.cap = "";
            }
        },
        onReadFullPage(docType) {
            switch (docType) {
                case "DPA":
                    this.gdprTitleToView = "DPA Fotografo";
                    this.gdprToView = this.getFilledDocument("DPA");
                    break;
                case "INFORMATIVA":
                    this.gdprTitleToView =
                        "Informativa Photogallery del fotografo agli utenti finali sul trattamento dei dati";
                    this.gdprToView = this.getFilledDocument("INFORMATIVA");
                    break;
                case "TERMINICONDIZIONIRIKORDAEVENTIFOTOGRAFO":
                    this.gdprTitleToView =
                        "Termini e condizioni del servizio Rikorda Eventi - Fotografo";
                    this.gdprToView = this.getFilledDocument(
                        "TERMINICONDIZIONIRIKORDAEVENTIFOTOGRAFO"
                    );
                    break;
                case "TERMINICONDIZIONIFOTOGRAFOUTENTI":
                    this.gdprTitleToView =
                        "Termini e condizioni del servizio Fotografo - Utenti finali";
                    this.gdprToView = this.getFilledDocument(
                        "TERMINICONDIZIONIFOTOGRAFOUTENTI"
                    );
                    break;
            }

            this.$bvModal.show(this.$refs.gdprViewer.id);
        },
        getFilledDocument(docType) {
            var doc;
            switch (docType) {
                case "DPA":
                    doc = this.gdpr.DPA;
                    break;
                case "INFORMATIVA":
                    doc = this.gdpr.Informativa;
                    break;
                case "TERMINICONDIZIONIRIKORDAEVENTIFOTOGRAFO":
                    doc = this.gdpr.TerminiCondizioniRikordaEventiFotografo;
                    break;
                case "TERMINICONDIZIONIFOTOGRAFOUTENTI":
                    doc = this.gdpr.TerminiCondizioniFotografoUtenti;
                    break;
                default:
                    doc = "";
            }

            Array.from(Object.keys(this.shop)).forEach((el) => {
                doc = doc.replaceAll(
                    "[[__" + el.toUpperCase() + "__]]",
                    this.shop[el]
                );
            });

            doc = doc.replaceAll(
                "[[__DATAACCETTAZIONE__]]",
                new Date().toLocaleDateString("it-IT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                })
            );

            doc = doc.replaceAll(
                "[[__DPO__]]",
                this.shop.dpo && this.shop.dpo.length > 0
                    ? this.shop.dpo
                    : "non è stato individuato"
            );

            return doc;
        },
        getDocumentUrlEndpoint() {
            return (
                process.env.VUE_APP_API_BASE_URL +
                process.env.VUE_APP_API_UPLOAD_GDPR_ENDPOINT +
                "?fkUtenteFotografo=" +
                this.shop.fkUtente +
                "&stato=CONFERMATO&uploadType=view"
            );
        },
        acceptGdpr() {
            this.$store
                .dispatch("ACCEPT_GDPR", {
                    shopData: this.shop
                })
                .then((result) => {
                    console.debug("BACKEND_ACCEPT_GDPR", result);
                    if (this.$store.getters.hasAcceptedGDPR) {
                        this.$emit("gdprAccepted");
                    }
                })
                .catch((error) => {
                    console.error("BACKEND_ACCEPT_GDPR", error);
                });
        },
        async handleFileChange(e) {
            const { valid } = await this.$refs.provider.validate(e);
            const file = this.$refs.customGdpr.files[0]; // <input type='file' />

            if (valid && file) {
                const uri =
                    process.env.VUE_APP_API_BASE_URL +
                    process.env.VUE_APP_API_UPLOAD_GDPR_ENDPOINT;
                const xhr = new XMLHttpRequest();
                const fd = new FormData();
                let that = this; // Vue
                xhr.open("POST", uri, true);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        switch (xhr.status) {
                            case 200:
                                console.debug("UPLOAD_CUSTOM_GDPR_OK");
                                break;
                            default:
                                console.debug("UPLOAD_CUSTOM_GDPR_ERROR");
                                break;
                        }
                    }
                };
                fd.append("file", file);
                fd.append("fkUtenteFotografo", this.shop.fkUtente);
                fd.append("uploadType", "upload_tmp");
                xhr.send(fd);
            }
        },
        handleDocTypeChange(docType) {
            console.debug("handleDocTypeChange", docType);
            this.hasCustomGDPR = docType == "custom";
        }
    },
    computed: {
        isStep1() {
            return this.wizardStep === 1;
        },
        isStep2() {
            return this.wizardStep === 2;
        },
        isStep3() {
            return this.wizardStep === 3;
        },
        isStep4() {
            return this.wizardStep === 4;
        }
    }
};
extend("required", {
    ...required,
    message: "Questo campo è obbligatorio"
});
extend("email", {
    ...email,
    message: "Inserisci un indirizzo email valido"
});
extend("ext", {
    ...ext,
    message: "Formato non valido. Selezionare un file in formato PDF."
});
</script>

<style>
div.textarea {
    border: 1px inset #ccc;
    background-color: white;
    width: 100%;
    height: 300px;
    overflow: auto;
}

.btn-rikorda-doctype:active,
.btn-rikorda-doctype:hover,
.btn-rikorda-doctype.active {
    color: white !important;
    border-color: var(--tiffany) !important;
    background-color: var(--tiffany) !important;
}
.btn-rikorda-doctype {
    color: var(--grigio-chiaro) !important;
    border-color: var(--tiffany) !important;
}

@media print {
    body * {
        visibility: hidden;
    }
}
</style>
